import * as React from "react";
import { ProductPromotions } from "@grandvisionhq/products";
import { isValidAlgoliaSearchConfig, QueryAlgoliaProducts } from "@grandvisionhq/search";
import { compose, withLazyLoading } from "@grandvisionhq/utils";
import { useMeta } from "../../../../context/context/MetaContext.js";
import { withBreakpointVisibility } from "../../../../hocs/hocs/with-breakpoint-visibility.js";
import { withHidableContent } from "../../../../hocs/hocs/with-hidable-content.js";
import { withBloomreachData } from "../../../../hocs/hocs/with-bloomreach-data.js";
import { withEditableContent } from "../../../../hocs/hocs/with-editable-content.js";
import { withAnchor } from "../../../../hocs/hocs/with-anchor.js";
import { useBloomreachPageName } from "../../../../hooks/hooks/use-bloomreach-page-name.js";
const CmsPromotion = ({ content }) => {
  const {
    products = [],
    productItemCompoundAlgolia = [],
    supertitle = "",
    title = "",
    queryString,
    ruleContext
  } = content;
  const promotionProducts = productItemCompoundAlgolia.length ? productItemCompoundAlgolia : products;
  const { algolia } = useMeta();
  const pageName = useBloomreachPageName();
  const query = productItemCompoundAlgolia.length ? productItemCompoundAlgolia[0].filterQuery : queryString;
  const rule = productItemCompoundAlgolia.length ? productItemCompoundAlgolia[0].ruleContext : ruleContext;
  const skus = React.useMemo(
    () => promotionProducts.map(({ sku }) => sku).filter((sku) => !!sku),
    [promotionProducts]
  );
  const config = React.useMemo(
    () => ({
      apiKey: algolia.apiKey,
      appId: algolia.appId,
      indexName: algolia.productIndex.name,
      facets: algolia.productIndex.facets
    }),
    [algolia]
  );
  const canSearch = promotionProducts.length > 0 || !!query || !!rule;
  if (!canSearch || !title && !supertitle || !isValidAlgoliaSearchConfig(config)) {
    console.error("Error rendering CMSPromotion, missing content or invalid search configuration");
    return null;
  }
  return /* @__PURE__ */ React.createElement(QueryAlgoliaProducts, { algoliaConfig: config, skus, queryString: query, ruleContext: rule }, (searchState) => {
    return !searchState.hasError && /* @__PURE__ */ React.createElement(
      ProductPromotions,
      {
        skus,
        products: searchState.result,
        supertitle,
        title,
        isLoading: searchState.isLoading,
        renderLocation: pageName
      }
    );
  });
};
const Promotion = compose(
  withLazyLoading,
  withBreakpointVisibility,
  withHidableContent,
  withBloomreachData,
  withEditableContent,
  withAnchor
)(CmsPromotion);
export {
  CmsPromotion,
  Promotion as default
};
//# sourceMappingURL=Promotion.js.map
